import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../../config/api";
import "../css/style.css";

function Footer() {
  const [popularCategories, setPopularCategories] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/categories/popular`)
      .then((res) => res.json())
      .then((data) => setPopularCategories(Array.isArray(data) ? data.slice(0, 5) : []))
      .catch(() => {
        // Fallback static categories
        setPopularCategories([
          { id: 1, name: "Fullstack Web Development" },
          { id: 2, name: "Database Architecture & SQL" },
          { id: 3, name: "Python Data Science & ML" },
          { id: 4, name: "Cloud & DevOps Essentials" }
        ]);
      });
  }, []);

  return (
    <footer>
      {/* ===== FOOTER MAIN ROW: Logo + Brand Content Side-by-Side with 3 Columns ===== */}
      <div className="footer-top">
        {/* Brand Side-by-Side: Large Logo + Description */}
        <div className="footer-brand-sidebyside">
          <div className="footer-logo-box">
            <img
              src="/consortiumelearning.png"
              alt="Consortium eLearning"
              className="footer-logo-main"
            />
          </div>
          <p className="footer-brand-sidebyside-text">
            Consortium eLearning platform offers innovative digital learning opportunities
            designed to empower students, scholars, and skilled workers worldwide.
          </p>
        </div>

        {/* Popular Categories */}
        <div className="footer-col">
          <h3>Popular Categories</h3>
          <ul>
            {popularCategories.length > 0 ? (
              popularCategories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/courses?category=${encodeURIComponent(cat.name)}`}>{cat.name}</Link>
                </li>
              ))
            ) : (
              <>
                <li><Link to="/courses?category=Fullstack%20Web%20Development">Fullstack Web Development</Link></li>
                <li><Link to="/courses?category=Database%20Architecture%20%26%20SQL">Database Architecture & SQL</Link></li>
                <li><Link to="/courses?category=Python%20Data%20Science%20%26%20ML">Python Data Science & ML</Link></li>
                <li><Link to="/courses?category=Cloud%20%26%20DevOps%20Essentials">Cloud & DevOps Essentials</Link></li>
              </>
            )}
          </ul>
        </div>

        {/* Head Office & Contact */}
        <div className="footer-col">
          <h3>Head Office</h3>
          <ul>
            <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FontAwesomeIcon icon={faEnvelope} style={{ color: '#0ea5e9', flexShrink: 0 }} />
              <a href="mailto:info@consortiumelearning.com">info@consortiumelearning.com</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FontAwesomeIcon icon={faPhone} style={{ color: '#0ea5e9', flexShrink: 0 }} />
              <a href="tel:+4402079460912">+44 (0) 20 7946 0912</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#0ea5e9', flexShrink: 0, marginTop: '4px' }} />
              <span style={{ lineHeight: '1.5', textAlign: 'left' }}>
                6660 Kennedy Road, Suites 201 & 205, Mississauga, Ontario L5T 2M9 Canada
              </span>
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/courses">All Courses</Link></li>
            <li><Link to="/goals">Goals</Link></li>
            <li><Link to="/accreditations">Accreditations</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/resources">Resources</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom Bar with Developer Credit */}
      <div className="footer-bottom">
        <p>Copyright © {new Date().getFullYear()} Consortium eLearning. All rights reserved.</p>
        <div className="developer-credit">
          Abdullah Siddique | Developed by <a href="https://nevoraprime.dev" target="_blank" rel="noopener noreferrer">NevoraPrime</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;